import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewEditCommonComponent } from '../view-edit-common/view-edit-common.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { ServicesService } from '../../services/services.service';
import { error } from 'jquery';
import { UserDetailsComponent } from '../user-details/user-details.component';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { Router } from '@angular/router';
import { TabService } from 'src/app/shared/tab.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-shared-table',
  templateUrl: './shared-table.component.html',
  styleUrls: ['./shared-table.component.css']
})
export class SharedTableComponent {
  allcolumns : any[] = []
  ref: DynamicDialogRef | undefined;
  @Input() columns: any[] = [];
  @Input() tableName: any;
  @Input() data: any[] = [];
  @Input() componentName:any;
  @Input() dropdownOptions: { [key: string]: string[] } = {};
  @Input() triggerDialog: any;
  sortedColumnIndex: number | null = null;
  sortOrder: 'ASC' | 'DESC' = 'ASC';
  selectedRows: any[] = [];  // Array to hold selected rows
  isAllSelected: boolean = false;
  @Output() sortChange: EventEmitter<{ columnKey: string, sortOrder: 'ASC' | 'DESC' }> = new EventEmitter();
  @Output() selectedRowsChange: EventEmitter<any[]> = new EventEmitter();
  @Output() invoiceEditActionEmit: EventEmitter<any[]> = new EventEmitter();
  @Output() columnsToExport: EventEmitter<any[]> = new EventEmitter();
  // @Output() invoiceActionEmit: EventEmitter<any[]> = new EventEmitter();
  @Output() reloadEvent: EventEmitter<number> = new EventEmitter();
  @Output() invoiceBudgetActionEmit = new EventEmitter<{ item: any; user: any }>();
  @Output() invoiceActionEmit = new EventEmitter<{rowItem:any, item: any; action: any }>();
  
  @Input() showFooterTotalRow: boolean = false;
  @Input() footerTotalData: any = {};
  
  selectAll: boolean = false;
  showHideColumnDropdown = false;
  sidebarType: any;
  userDetails: any;
  colToExport:any;
  colomnData:any;
  RoleSuperAdmin: any;
  userRole:any;
  constructor( private sanitizer: DomSanitizer,public accessControlService: AccessControlService,private dialog: MatDialog, public dialogService: DialogService, private cdr: ChangeDetectorRef,
    private services : ServicesService,private emsServices: EmsServicesService, private router: Router, private tabService: TabService
  ) { }

  tooltipOptions = {
    showDelay: 150,
    autoHide: false,
    outerHeight: '50px'
};

ngOnInit(): void {
  this.userDetails = JSON.parse(localStorage.getItem('user_details')!)
  this.userDetails?.userRole.filter((role: any) => {
    if (role?.roleName == 'ROLE_SUPERUSER') {
      this.RoleSuperAdmin = role?.roleName
    }
  });
  this.userRole = this.userDetails?.userRole[0].roleName 
  this.sidebarType = localStorage.getItem('sidebarType')!;
  this.updateTableHeight();
  this.cdr.detectChanges();
  this.getUserTableListByUserId()
    this.selectAll = this.allcolumns.every(col => col.showColumn);

}

updateTableHeight() {
  setTimeout(() => {
    const tableElement = document.querySelector(".p-datatable");

    if (!tableElement) return;

    if (this.sidebarType === 'top') {
      tableElement.classList.add("top");
    } else {
      tableElement.classList.remove("top");
    }
  }, 0); // Adjust delay if needed
}

sortApproval(data:any){
 return data.sort((a:any, b:any) => a.sequence - b.sequence);
}

  sortData(columnIndex: number, columnKey: string): void {
    this.sortOrder = this.sortedColumnIndex === columnIndex && this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    this.sortedColumnIndex = columnIndex;

    this.data.sort((a, b) => {
      const valueA = a[columnKey];
      const valueB = b[columnKey];

      console.log(`Sorting by column: ${columnKey} (index: ${columnIndex}), Order: ${this.sortOrder}`);

      // Sorting logic based on the order
      if (valueA < valueB) return this.sortOrder === 'ASC' ? -1 : 1;
      if (valueA > valueB) return this.sortOrder === 'ASC' ? 1 : -1;
      return 0;
    });
    // Emit the sort change event to the parent component
    this.sortChange.emit({ columnKey, sortOrder: this.sortOrder });

    console.log('Sorted Data:', this.data);
  }

  openRowDetailsDialog(column: any, row: any): void {
    console.log(column)
    if (column) {
      const columnKey = column.key; 
      let filteredColumns = this.columns.filter(col => col.header !== 'Action');
      let rowData = { ...row };
     
       // Check if "Current Approver" exists in columns
       this.columns.forEach(col => {
        if (col.key === 'approvalUser') {
            if (col.type === 'currentApprover') {
                // Assign the current approver separately
                rowData['currentApprover'] = this.getCurrentApprover(row.approvalUser || []);
            } else if (col.type === 'approvalUser') {
                // Keep the full approvalUser list
                rowData['approvalUser'] = row.approvalUser;
            }
        }
    });
    

      this.ref = this.dialogService.open(ViewEditCommonComponent, {
        data: {
          rowData: rowData,
          columns: filteredColumns,
          triggerDialog: columnKey, 
          printData: true,
          componentName: column.componentName,
          viewHistory: column.viewHistory
        },
        width: '75vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true
      });
  
      this.ref.onClose.subscribe((result: any) => {
        // if (result) {
          console.log('Dialog closed with result:', result);
          this.reloadEvent.emit(result); 
        // }
      });
    } 

    else if (row) {
      const columnKey = this.columns.find(col => col.viewDialog === true)?.key; // Get column with viewDialog: true
      if (columnKey) {
        this.ref = this.dialogService.open(ViewEditCommonComponent, {
          data: {
            rowData: row,
            columns: this.columns.map(col => col.header),
            triggerDialog: columnKey, 
            printData: true,
          },
          width: '65vw',
          contentStyle: { overflow: 'auto', position: "top" },
          draggable: true
        });
  
        this.ref.onClose.subscribe((result: any) => {
          // if (result) {
            console.log('Dialog closed with result:', result);
            this.reloadEvent.emit(result); 
          // }
        });
      }
    }
  }
  
  getCurrentApprover(approvalUsers: any[]): string {
    const approver = approvalUsers.find(user => user.approvalStatus === 1);
    return approver ? approver.name : 'N/A';
  }

  
  toggleSelectAll() {
    if (this.isAllSelected) {
      this.data.forEach(row => row.selected = true);
      this.selectedRows = [...this.data];
      console.log(this.selectedRows)
    } else {
      this.data.forEach(row => row.selected = false);
      this.selectedRows = [];
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }

  
  onRowSelect(row: any) {
    if (row.selected) {
      this.selectedRows = this.data.filter(r => r.selected);
    } else {
      this.selectedRows = this.selectedRows.filter(r => r !== row);
    }
  
    this.isAllSelected = this.data.every(r => r.selected);
    this.selectedRowsChange.emit(this.selectedRows); 

  }
  invoiceEditAction(row:any){
    this.selectedRows = this.data.filter(r => r.id == row.id);
    this.invoiceEditActionEmit.emit(this.selectedRows); 
  }
  invoiceAction(rowItem:any,item:any,action:any){
      console.log(item)
      if(item?.isActionOnLineItem){
      if(action == 'approve' || action == 'reject' || action == 'comment' ){
          const colom = { showColumn: true, key: "internalInvoiceNumber", header: "Invoice No", sortable: false, type: "text", viewDialog: true } 
          this.openRowDetailsDialog(colom,rowItem)
        }
    }else{
      this.invoiceActionEmit.emit({rowItem,item,action}); 
    }
  }
  invoiceBudgetAction(item:any, user:any){
    console.log("item",item)
    const lineitem = { item, user };
    // this.invoiceBudgetActionEmit.emit(lineitem);
    this.invoiceBudgetActionEmit.emit({ item, user });
  }


  getStatusText(value: string): string {
    switch (value) {
      case 'PENDING_BUDGET_UPDATE': return 'Pending Budget Update';
      case 'BUDGET_RAISED': return 'Budget Raise';
      case 'PARTIALLY_APPROVED': return 'Partially Approved';
      case 'WITHIN_BUDGET': return 'Within Budget';
      case 'OVERRUN': return 'Overrun';
      case 'COMMENTED': return 'Commented';
      case 'REJECTED': return 'Rejected';
      case 'CREATED': return 'Created';
      case 'PENDING': return 'Pending';
      case 'APPROVED': return 'Approved';
      case 'MULTI_USER': return 'Multi User';
      case 'STAND_ALONE': return 'Stand Alone';
      case 'CORPORATE': return 'Corporate';
      case 'CASH': return 'Cash';
      case 'NOT_PAID': return 'Not Paid';
      case 'PAID': return 'Paid';
      case 'EAST': return 'East';
      case 'Z_EAST1': return 'Z_East1';
      case 'Z_NORTH1': return 'Z_North1';
      case 'NORTH': return 'North';
      case 'WAREHOUSE': return 'Warehouse';
      case 'MANPOWER': return 'Manpower';
      default: return value;
    }
  }
 
toggleAllColumns() {
  this.allcolumns.forEach(col => col.showColumn = this.selectAll);
  this.toggleColumnVisibility(); // Sync with backend/localStorage
}
deselectAllColumns() {
  this.selectAll = false;
  this.allcolumns.forEach(col => col.showColumn = false);
  this.toggleColumnVisibility();
}
  toggleColumnVisibility() {
    // console.log("--------------" + JSON.stringify(this.colomnData))
  const allData = JSON.parse(localStorage.getItem('columnToExport') || '{}');
  allData[this.componentName] = this.allcolumns
  .filter(col => col.showColumn)
  .map(col => col.key);

    localStorage.setItem('columnToExport', JSON.stringify(allData));  

    this.data?.forEach((row: any) => {
      row.selected = false;
      this.isAllSelected = false;
    });
  
    const colom = JSON.stringify(this.allcolumns);
    const payload = 
      {
        "userId": this.userDetails?.id,
        "tableName": this.tableName,
        "tableJson": colom
    }
    this.services.viewColom(payload).subscribe((res: any) => {
      console.log(res)
      this.getUserTableListByUserId()
      this.selectAll = this.allcolumns.every(col => col.showColumn);
      if(this.selectAll){
        this.selectAll = true

      }else{
        this.selectAll = false
      }

    })
  }
  

  getUserTableListByUserId(){
    this.services.getUserTableListByUserId(this.userDetails?.id).subscribe((res: any) => {
      // console.log(res?.responseObject,this.tableName)
      this.colomnData = res.responseObject[this.tableName]
      if(this.colomnData){
        this.columns = JSON.parse(this.colomnData)
        this.allcolumns = JSON.parse(this.colomnData)
        // if(this.tableName === 'Ageing-Report'){
        //   const data = 
        //   [
        //     {aligntextRight:true, showColumn: true, sortingColumn: '', key: 'totalInvoiceCount', header: 'Invoice Count', sortable: false, type: 'text', viewDialog: false },
        //     {aligntextRight:true, showColumn: true, sortingColumn: '', key: 'totalVendorInvoiceLineItemCount', header: 'Vendor Invoice Line Item Count', sortable: false, type: 'text', viewDialog: false },
        //     {aligntextRight:true, showColumn: true, sortingColumn: '', key: 'totalAmountExclGst', header: 'Amount Excl. GST', sortable: false, type: 'text', viewDialog: false },
        //   ]
        //   data.forEach((el:any)=>{
        //     this.columns.push(el)
        //     this.allcolumns.push(el)
        //   })
        // }
      }else{
        this.columns = this.columns
        this.allcolumns = this.columns
      }
      // console.log(colomData)
      // console.log(this.columns)
    },error => {
      console.log(error)
      this.columns = this.columns
      this.allcolumns = this.columns
    })
  }

 
  filteredApprovers(list: any[], row: any): any[] {
    // console.log(list)
    if (!list?.length) return [];

    const statusList = list.map((item) => item.approvalStatus);
  
    const countOf2 = statusList.filter(status => status === 2).length;
    const countOf5 = statusList.filter(status => status === 5).length;
    const countOf9 = statusList.filter(status => status === 9).length;
    const totalItems = statusList.length;
    
    // Condition: all must be 2 or exactly one 5
    if ((countOf2 + countOf5 === totalItems) && (countOf5 === 1)) {
      return list.slice(-3);  // last 3 items
    } 
    
    // Partially Approved  Condition: all must be 2 or exactly one 9
    if ((countOf2 + countOf9 === totalItems) && (countOf9 === 1)) {
      return list.slice(-3);  // last 3 items
    } 

    if (list.every(item => item.approvalStatus === 2)) {
      return list.slice(-3);
    }
    // const targetStatuses = [5, 6];
    // if(targetStatuses){
    //   return list.filter(user => targetStatuses.includes(user.approvalStatus))
    //   .slice(-3); // get last 3 of those
    // }

    const statusMapping: Record<string, number> = {
      COMMENTED: 4,
      REJECTED: 3,
      PENDING_BUDGET_UPDATE: 2,
      // PARTIALLY_APPROVED:9
    };
  
    // Find the current approver based on row.approvalStatus
    const approvalStatus = statusMapping[row?.approvalStatus] ?? 1;
    const currentIndex = list.findIndex(item => item.approvalStatus === approvalStatus && item.viewStatus === 1);
  
    if (currentIndex === -1) return []; 
  
    const excludeAfterUser = row?.approvalStatus === "COMMENTED" || row?.approvalStatus === "REJECTED";

    return list
      .filter((_, index) => 
        index === currentIndex || index === currentIndex - 1 || 
        (!excludeAfterUser && index === currentIndex + 1) 
      )
      .map((item, index) => ({
        ...item,
        position: index === currentIndex ? 'current' : 'before'
      }));
  }



  userDetailsClick(user:any){
    console.log(user)
    const postData  = [
      {    
        "key": "USER_ID",
        "value": user.userId
      },
      {
        "key":"PLATFORM_IN",
        "value":"ems"
      }
    ]
    let userDetail : any
    this.emsServices
      .getUsers(postData, 0, 20,'id','DESC')
      .subscribe((data: any) => {
        console.log(data?.responseObject?.content)
        userDetail = data?.responseObject?.content
        if(userDetail){
          this.showUserDetails(userDetail)
        }
      });
  }
  showUserDetails(userDetail:any){
    this.ref = this.dialogService.open(UserDetailsComponent, {
          header: `User Details`,
          data: {
            data: userDetail[0],
          },
          width: '70vw',
          contentStyle: { overflow: 'auto', position: "top" },
          styleClass: 'custom-user-dialog', 
          draggable: true
        });
  
        this.ref.onClose.subscribe((result: any) => {
          // if (result) {
            console.log('Dialog closed with result:', result);
            // this.reloadEvent.emit(result); 
          // }
        });
  }
 
  getDisplayValue(value: any): any {
    return (typeof value === 'number' && value === 0) ? '' : this.getStatusText(value);
  }
  
  redirection(column:any, row:any,clicked:any,value:any){
    if(value > 0){
      if(clicked == 'invoiceCount02'){
        const updatedFilters = [
          {
            key: "INVOICE_IN",
            value: row.invoiceId02
          },
          {
            key: "USER_ID_IN",
            value: row.userId
          }
        ]
        const allTabs = this.tabService?.tabs;
        allTabs.forEach((el:any,i:any)=>{
          if(el.path.includes('invoices/all-invoice')){
            this.tabService.updateFilterData(i, updatedFilters);
            this.router.navigate(['invoices/all-invoice'])
          }
          else{
            this.tabService.addTab({
              label: "All Invoices", path: '/invoices/all-invoice',
              fullPath: '',
              filterData: updatedFilters
            });
            this.router.navigate(['invoices/all-invoice'])
          }
        })
      }
      if(clicked == 'invoiceCount35'){
        const updatedFilters = [
          {
            key: "INVOICE_IN",
            value: row.invoiceId35
          },
          {
            key: "USER_ID_IN",
            value: row.userId
          }
        ]
        const allTabs = this.tabService?.tabs;
        allTabs.forEach((el:any,i:any)=>{
          if(el.path.includes('invoices/all-invoice')){
            this.tabService.updateFilterData(i, updatedFilters);
            this.router.navigate(['invoices/all-invoice'])
          }
          else{
            this.tabService.addTab({
              label: "All Invoices", path: '/invoices/all-invoice',
              fullPath: '',
              filterData: updatedFilters
            });
            this.router.navigate(['invoices/all-invoice'])
          }
        })
      }
      if(clicked == 'invoiceCount610'){
        const updatedFilters = [
          {
            key: "INVOICE_IN",
            value: row.invoiceId610
          },
          {
            key: "USER_ID_IN",
            value: row.userId
          }
        ]
        const allTabs = this.tabService?.tabs;
        allTabs.forEach((el:any,i:any)=>{
          if(el.path.includes('invoices/all-invoice')){
            this.tabService.updateFilterData(i, updatedFilters);
            this.router.navigate(['invoices/all-invoice'])
          }
          else{
            this.tabService.addTab({
              label: "All Invoices", path: '/invoices/all-invoice',
              fullPath: '',
              filterData: updatedFilters
            });
            this.router.navigate(['invoices/all-invoice'])
          }
        })
      }
      if(clicked == 'invoiceCount11Plus'){
        const updatedFilters = [
          {
            key: "INVOICE_IN",
            value: row.invoiceId11Plus
          },
          {
            key: "USER_ID_IN",
            value: row.userId
          }
        ]
        const allTabs = this.tabService?.tabs;
        allTabs.forEach((el:any,i:any)=>{
          if(el.path.includes('invoices/all-invoice')){
            this.tabService.updateFilterData(i, updatedFilters);
            this.router.navigate(['invoices/all-invoice'])
          }
          else{
            this.tabService.addTab({
              label: "All Invoices", path: '/invoices/all-invoice',
              fullPath: '',
              filterData: updatedFilters
            });
            this.router.navigate(['invoices/all-invoice'])
          }
        })
      }
    }
  }

  getEncodedInvoiceUrl(url: string | null | undefined): SafeResourceUrl {
    if (!url) return '';
      const fixedUrl = url.replace(/#/g, '%23');
    const encodedUrl = encodeURI(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(fixedUrl );
  }
  getExtType(url:any){
    const ext = url.split('.').pop().split(/\#|\?/)[0];
    return ext
  }
}
